import axios from 'axios'
import Cookies from 'js-cookie'
import router from '@/router'
import QS from 'qs'
import {Message} from 'element-ui'

let tip = '0'

// 创建axios请求实例
const request = axios.create({
  baseURL: process.env.API_ROOT, // 设置跨域代理接口统一的前置地址
  timeout: 600000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'/* ,
    'Authorization': Cookies.get('courseauth') */
  },
  devServer: {
    proxy: {
      '/': {
        target: '//devapi.course.gaokaoq.com',
        changeOrigin: true
      }
    }
  }
})
axios.defaults.baseURL = process.env.API_ROOT
axios.defaults.timeout = 600000 // 超时时间
axios.defaults.retry = 3 // 请求次数
axios.defaults.retryDelay = 1000 // 请求间隙
// 添加请求拦截器
request.interceptors.request.use(function (request) {
  // request.headers['Authorization'] = Cookies.get('courseauth')
  return request
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
request.interceptors.response.use(function (response) {
  /* let status = response.data.status */
  /* if (response.headers.authorization) {
    // 设置cookie的保存时间为1天
    Cookies.set('authorization', response.headers.authorization)
  } */
  if (response.data.status === 1) {
    // 只返回数据
    return response.data
  } else if (response.data.status === -9) {
    // 账号已存在
    return response.data
  } else if (response.data.status === 2000) {
    // token失效
    if (tip == 0) { // 只提示一次
      Message({
        message: response.data.msg
      })
      tip = 1
    }
    setTimeout(() => {
      Cookies.remove('courseauth')
      Cookies.remove('courserandom')
      router.push({
        path: '/login',
        query:{
          redirect: location.hostname  // 防止从外部进来登录
        }
      })
    }, 1500)
  } else {
    Message({
      message: response.data.msg
    })
    return response.data
  }
}, function (error) {
  Message({
    message: '接口异常'
  })
  // 请求超时， 重新请求
  var config = error.config
  // If config does not exist or the retry option is not set, reject
  if (!config || !config.retry) return Promise.reject(error)

  // Set the variable for keeping track of the retry count
  config.__retryCount = config.__retryCount || 0

  // Check if we've maxed out the total number of retries
  if (config.__retryCount >= config.retry) {
    // Reject with the error
    return Promise.reject(error)
  }

  // Increase the retry count
  config.__retryCount += 1

  // Create new promise to handle exponential backoff
  var backoff = new Promise(function (resolve) {
    setTimeout(function () {
      resolve()
    }, config.retryDelay || 1)
  })

  // Return the promise in which recalls axios to retry the request
  return backoff.then(function () {
    return axios(config)
  })
})


const get = (url, data) => {
  let dataparams = {
    token: Cookies.get('courseauth'),
    random: Cookies.get('courserandom')
  }
  return request.get(url, {
    params: Object.assign(dataparams, data)
  })
}
const post = (url, data) => {
  let dataparams = {
    token: Cookies.get('courseauth'),
    random: Cookies.get('courserandom')
  }
  return request.post(url, QS.stringify(Object.assign(dataparams, data)))
}
// const delete = (url, data) => request.delete(url, data)
// const head = (url, data) => request.head(url, data)
// const options = (url, data) => request.options(url, data)
// const put = (url, data) => request.put(url, data)
// const patch = (url, data) => request.patch(url, data)

export {
  get,
  post
}



// WEBPACK FOOTER //
// ./src/utils/request.js